import { IsString, IsNotEmpty } from 'class-validator';

export class CreateGroupTypeDTO {
  public groupType_id! : number | null;

  public icon! : string | null;

  @IsNotEmpty()
  @IsString()
  public name! : string;

  @IsString()
  public tenant! : string;
}
